import BankPaymentEntries from "../../BankPaymentEntry/BankPaymentEntries";

const BankPaymentEntryPage = () => {
  return <BankPaymentEntries />;
};

export default BankPaymentEntryPage;
